import React from "react";
import { useNavigate } from "react-router";
import { ScrollArea, ScrollBar } from "@acme/ui/scroll-area";
import { Card, CardHeader, CardTitle, CardContent } from "@acme/ui/card";
import { ArrowRightIcon } from "lucide-react";
import { DiPython } from "react-icons/di";

interface Project {
	id: string;
	title: string;
	type: string;
	createdAt: string;
}

const projects = [
	{
		id: "1",
		title: "Project 1",
		type: "JavaScript",
		createdAt: "2023-10-01",
	},
	{ id: "2", title: "Project 2", type: "Python", createdAt: "2023-10-05" },
	{ id: "2", title: "Project 2", type: "Python", createdAt: "2023-10-05" },
	{ id: "2", title: "Project 2", type: "Python", createdAt: "2023-10-05" },
	{ id: "2", title: "Project 2", type: "Python", createdAt: "2023-10-05" },
	{ id: "2", title: "Project 2", type: "Python", createdAt: "2023-10-05" },
	{ id: "2", title: "Project 2", type: "Python", createdAt: "2023-10-05" },
	{ id: "2", title: "Project 2", type: "Python", createdAt: "2023-10-05" },
	{ id: "2", title: "Project 2", type: "Python", createdAt: "2023-10-05" },
	{ id: "2", title: "Project 2", type: "Python", createdAt: "2023-10-05" },
	{ id: "2", title: "Project 2", type: "Python", createdAt: "2023-10-05" },
	{ id: "2", title: "Project 2", type: "Python", createdAt: "2023-10-05" },
	{ id: "2", title: "Project 2", type: "Python", createdAt: "2023-10-05" },
	// ... add more as needed
];

export function RecentSessions() {
	const navigate = useNavigate();

	return (
		<div className="p-4">
			<h1 className="text-2xl font-bold mb-4">Recent Live Sessions</h1>
			<ScrollArea className="pb-4">
				<div className="flex gap-4 w-max p-4">
					{projects.map((project) => (
						<Card
							key={project.id}
							className="min-w-[250px] cursor-pointer hover:shadow-lg transition-shadow"
							onClick={() => navigate(`/dashboard/projects/${project.id}`)}
						>
							<CardHeader className="p-4">
								<div className="flex items-center gap-2 mb-2">
									<DiPython className="h-6 w-6 text-gray-500" />
									<CardTitle className="text-xl font-semibold">
										{project.title}
									</CardTitle>
								</div>
							</CardHeader>
							<CardContent className="px-4 pb-4">
								<p className="text-sm text-gray-600">Type: {project.type}</p>
								<p className="text-xs text-gray-500">
									Created At: {project.createdAt}
								</p>
							</CardContent>
						</Card>
					))}
				</div>
				<ScrollBar orientation="horizontal" />
			</ScrollArea>
			<button
				type="button"
				onClick={() => navigate("/projects")}
				className="flex items-center gap-2 text-primary font-semibold"
			>
				See All
				<ArrowRightIcon className="h-4 w-4" />
			</button>
		</div>
	);
}
